export default function Loader() {
  return (
    <div
      style={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 'var(--space-5)',
      }}
    >
      <img
        src="/assets/oumma-mark.svg"
        alt=""
        width="52"
        height="52"
        className="oumma-loader-logo"
      />
      <span
        className="oumma-loader-text"
        style={{
          fontFamily: 'var(--font-display)',
          fontWeight: 600,
          fontSize: 16,
          letterSpacing: '0.04em',
        }}
      >
        Chargement
        <span className="oumma-loader-dot1">.</span>
        <span className="oumma-loader-dot2">.</span>
        <span className="oumma-loader-dot3">.</span>
      </span>
    </div>
  )
}
